"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "router", {
    enumerable: true,
    get: function() {
        return router;
    }
});
const _router = require("./global-state/router");
const router = _router.router;

//# sourceMappingURL=imperative-api.js.map
